import { ax } from '../utils/axios/axios'
import { BASE_API_URL } from '../constants'

interface DeleteCostItemOptions {
  drsId: string,
  costItemId: string,
  roleId: string,
}

export const apiDRSCostItemDelete = ({
  drsId,
  costItemId,
  roleId,
}: DeleteCostItemOptions) => {
  const options = {
    method: 'DELETE',
    url: `${BASE_API_URL}/drs/${drsId}/costItems/${costItemId}`,
    params: {
      role: roleId,
      reqDev: 'web',
    },
  }
  return ax(options)
}
